module.exports = __webpack_public_path__ + "img/icon-expand.ce9d73a8.svg";